var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center-content"},[_c('div',{staticClass:"center-box"},_vm._l((_vm.list),function(item){return _c('div',{key:item.title,staticClass:"center-item"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(item.title))]),_c('div',{staticClass:"num"},[_vm._v(_vm._s(item.num))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }